import(/* webpackMode: "eager" */ "/home/ubuntu/download/69aa2d634fab3d0014559bb8/prep_platform/src/app/forgot-password/page.tsx");
